import React, { Component } from 'react';
import logo from './../data-broker-logo-white.gif'; // Tell Webpack this JS file uses this image

class CompleteSection extends Component {
  render() {
    return (
      <section className="complete-section">
        <div className="complete-section__inner">
          <a href="/" className="complete-section__logo">
            <img src={ logo } alt="Databroker logo" />
          </a>


          <div className="complete-section__circle">
            <div className="bubble-cta colour--white"><i className="back"></i><i className="fore"></i>
            <div>
              <p className="h3">You're all done! Your details have been successfully recieved and a member of staff will be in touch shortly with a bespoke plan.<br/><a className="h6 colour--yellow" href="//data-broker.co.uk">Return to the Databroker site</a></p>
            </div>
            </div>
          </div>
        </div>

      </section>
    )
  }
}

export default CompleteSection
